import { render, staticRenderFns } from "./baseInfo.vue?vue&type=template&id=dff8c8de&scoped=true&"
import script from "./baseInfo.vue?vue&type=script&lang=js&"
export * from "./baseInfo.vue?vue&type=script&lang=js&"
import style0 from "./baseInfo.vue?vue&type=style&index=0&id=dff8c8de&lang=scss&scoped=true&"
import style1 from "./baseInfo.vue?vue&type=style&index=1&id=dff8c8de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dff8c8de",
  null
  
)

export default component.exports